import axios from 'axios';
import { OrganizationProps } from "../../interfaces/Organization";
import { RestApiState } from '../../interfaces/Rest/types';


const getCsrftoken = ():string => {
    const cookies = document.cookie.split(';')
    var result = ""
    
    for (let item of cookies) {
        if (item.trim().startsWith("csrftoken=")) {
            result = item.trim().replace('csrftoken=', '')
        }
    }
    return result
}

type OrganizationParams = {
    organization: string
}


export const FetchMyOrganization = async (
    setValue: (key: string,  value: OrganizationProps) => void
) => {
    axios.get<OrganizationProps>(`${process.env.REACT_APP_DJANGO_SERVER_URL}/api/client/v1/organization/details`,
        { withCredentials: true }
    )
    .then(response => {
            if (response.status === 200) {
                var details:OrganizationProps = response.data
                setValue("organization", details)
            }
        }
    )
    .catch(error => {
        console.error('Error fetching accumulator details:', error);
    });
}

export const FetchStaffOrganization = async (
    id: string,
    setValue: (key: string,  value: OrganizationProps) => void) => {

    axios.get<OrganizationProps>(`${process.env.REACT_APP_DJANGO_SERVER_URL}/api/staff/v1/organization/${id}/details`,
        { withCredentials: true }
    )
    .then(response => {
            if (response.status === 200) {
                var details:OrganizationProps = response.data
                setValue("organization", details)
            }
        }
    )
    .catch(error => {
        console.error('Error fetching accumulator details:', error);
    });
}


export const UpdateMyOrganization = async (organization: OrganizationProps, statusSetter:(value: RestApiState) => void) => {
    const dataToSend = new FormData();
    dataToSend.append('organization_name', organization.organization_name);
    dataToSend.append('address', organization.address);
    dataToSend.append('phone', organization.phone);
    dataToSend.append('email', organization.email);
    dataToSend.append('allow_building_grouping', organization.allow_building_grouping === true ? 'true' : 'false');
    dataToSend.append('allow_custom_model_grouping', organization.allow_custom_model_grouping === true ? 'true' : 'false');

        // Append the image if available
    if (organization.imagePreview) {
        dataToSend.append('organization_image', organization.imagePreview);
    }


    axios.put<OrganizationProps>(`${process.env.REACT_APP_DJANGO_SERVER_URL}/api/client/v1/organization/details`,
        dataToSend,
        {    
            headers: {
                'X-CSRFToken': getCsrftoken(),
                'Content-Type': 'multipart/form-data'
            },
            withCredentials: true        
        }
    )
    .then(response => {
            if (response.status === 200) {
                var details:any = response.data
                statusSetter(RestApiState.Success)
            }
        }
    )
    .catch(error => {
        console.error('Error fetching accumulator details:', error)
        if (error.response.status === 400) {
            statusSetter(RestApiState.BadRequest)
        } else if (error.response.status === 500) {
            statusSetter(RestApiState.ServerError)
        } else {
            statusSetter(RestApiState.Unknown)
        }
    });
}

export const UpdateOrganization = async (organization: OrganizationProps, statusSetter:(value: RestApiState) => void) => {
    const dataToSend = new FormData();
    dataToSend.append('organization_name', organization.organization_name);
    dataToSend.append('address', organization.address);
    dataToSend.append('phone', organization.phone);
    dataToSend.append('email', organization.email);
    dataToSend.append('allow_building_grouping', organization.allow_building_grouping === true ? 'true' : 'false');
    dataToSend.append('allow_custom_model_grouping', organization.allow_custom_model_grouping === true ? 'true' : 'false');

        // Append the image if available
    if (organization.imagePreview) {
        dataToSend.append('organization_image', organization.imagePreview);
    }


    axios.put<OrganizationProps>(`${process.env.REACT_APP_DJANGO_SERVER_URL}/api/staff/v1/organization/${organization.id}/details`,
        dataToSend,
        {    
            headers: {
                'X-CSRFToken': getCsrftoken(),
                'Content-Type': 'multipart/form-data'
            },
            withCredentials: true        
        }
    )
    .then(response => {
            if (response.status === 200) {
                var details:any = response.data
                statusSetter(RestApiState.Success)
            }
        }
    )
    .catch(error => {
        console.error('Error fetching accumulator details:', error)
        if (error.response.status === 400) {
            statusSetter(RestApiState.BadRequest)
        } else if (error.response.status === 500) {
            statusSetter(RestApiState.ServerError)
        } else {
            statusSetter(RestApiState.Unknown)
        }
    });
}


export type OrganizationOptions = {
    id : number | undefined | string,
    organization_name: string,
}


export const AxiosOrganizationOptions = async (
    setValue: (value: OrganizationOptions[]) => void) => {

    axios.get<OrganizationOptions[]>(`${process.env.REACT_APP_DJANGO_SERVER_URL}/api/staff/v1/organization/choice-list`,
        { withCredentials: true }
    )
    .then(response => {
            if (response.status === 200) {
                var details:OrganizationOptions[] = response.data
                setValue(details)
            }
        }
    )
    .catch(error => {
        console.error('Error fetching accumulator details:', error);
    });
}